import { message } from 'components';
import { aiAgentCenterMessages } from 'messages';
import { useInterceptAIChatSessionMutation } from 'services';
import { ChatSessionDto } from 'types';

export const useInterceptAIChatSession = () => {
  const [handleIntercept, { isLoading }] = useInterceptAIChatSessionMutation();

  const onInterceptChatSession = (chatSessionId: number, callBack: (data: ChatSessionDto) => void) => {
    return handleIntercept(chatSessionId)
      .unwrap()
      .then((res) => {
        message.success(aiAgentCenterMessages.interceptChatSuccess);
        callBack(res.data);
      });
  };

  return {
    onInterceptChatSession,
    isLoading
  };
};
